import React from 'react';
import PropTypes from 'prop-types';
import {Tag} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import actions from '@web/redux/collections/actions';
import {UserContext} from '@web/hooks/context';

CollectionSyncButton.propTypes = {
  collection: PropTypes.object,
};

function CollectionSyncButton(props) {
  const dispatch = useDispatch();
  const [userId, h] = React.useContext(UserContext);
  const dataPath = [h, props.collection.collectionId].join("/");
  const syncError = useSelector((state) => state.Collections[props.collection?.collectionId]?.syncError);
  const hasNew = useSelector((state) => state.Collections[props.collection?.collectionId]?.hasNew);

  const loadContent = () => {
    !!props.collection.collectionId &&
    dispatch(actions.fetch(props.collection.collectionId,{
      path: dataPath,
    }));
  };

  // console.log("data path", dataPath);

  return <label>
    {/*{props.collection?.schema &&*/}
    {/*  !syncError &&*/}
    {/*  !hasNew?.count &&*/}
    {/*  <Tag color="success">LIVE</Tag>}*/}
    {props.collection &&
      !!hasNew?.count &&
      <Tag
        color="success"
        onClick={loadContent}
        className="cursor-pointer rounded"
        // closable
      >
        {hasNew.count} NEW&nbsp;&nbsp;
      </Tag>}
  </label>
}

export default CollectionSyncButton;
